import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { PermissionComponent } from "./components/permission/permission.component";
import { EditContentComponent } from "./components/edit-content/edit-content.component";
import { ErrorComponent } from "./components/error/error.component";
import { AccessDeniedComponent } from "./components/access-denied/access-denied.component";
import { CanActivateService } from "./services/can-activate/can-activate.service";
import { BrandAccountComponent } from "./components/brand-account/brand-account.component";
import { RecommitProcessComponent } from "./components/recommit-process/recommit-process.component";
import { FailedRecommitsComponent } from "./components/failed-recommits/failed-recommits.component";
import { MrcComponent } from "./components/mrc/mrc.component";
import { RewardsPermissionComponent } from "./components/rewards-permission/rewards-permission.component";
import { SsoComponent } from "./components/sso/sso.component";
import { CallbackComponent } from "./components/callback/callback.component";

const routes: Routes = [
  { path: "callback", component: CallbackComponent },
  { path: "", pathMatch: "full", redirectTo: "landing" },
  {
    path: "landing",
    component: LandingPageComponent,
    canActivate: [CanActivateService],
  },
  { path: "sso", component: SsoComponent },
  {
    path: "permission",
    component: PermissionComponent,
    canActivate: [CanActivateService],
  },
  { path: "mrc", component: MrcComponent, canActivate: [CanActivateService] },
  {
    path: "edit-content",
    component: EditContentComponent,
    canActivate: [CanActivateService],
  },
  { path: "brand-account", component: BrandAccountComponent },
  { path: "error", component: ErrorComponent },
  { path: "access-denied", component: AccessDeniedComponent },
  { path: "recommit-process", component: RecommitProcessComponent },
  { path: "failed-recommits", component: FailedRecommitsComponent },
  {
    path: "rewards-permission",
    component: RewardsPermissionComponent,
    canActivate: [CanActivateService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
